var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 14.8153H9.95911V16.4072H1.99951V14.8153ZM1.99951 9.2436H17.9187V10.8355H1.99951V9.2436ZM1.99951 3.67188H17.9187V5.2638H1.99951V3.67188ZM14.7349 14.8153V12.4274H16.3268V14.8153H18.7147V16.4072H16.3268V18.7951H14.7349V16.4072H12.347V14.8153H14.7349Z",
    fill: "#680DE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddList);
export default __webpack_public_path__ + "static/media/add-list.ad3fc1d7680406056c93bd2e38a23619.svg";
export { ForwardRef as ReactComponent };